"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetFooterContent = void 0;
var _environment = require("@ori/environment");
var _i18n = require("@ori/i18n");
var _staticApiClientReact = require("@ori/static-api-client-react");
var _utils = require("../utils");
/* istanbul ignore file -- api */

const useGetFooterContent = () => {
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  const {
    language
  } = (0, _i18n.useLanguage)();
  const result = (0, _staticApiClientReact.useGetTenantApplicationsFooter)(tenant, {
    lang: language
  }, {
    swr: {
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false
    }
  });
  return {
    ...result,
    data: result.data?.data ? (0, _utils.parseFooterData)(result.data.data) : null
  };
};
exports.useGetFooterContent = useGetFooterContent;
